module.exports = __webpack_public_path__ + "media/images/loading-spinner-white-3c541d2b.svg";